import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="py-24 md:py-32 bg-[#080808] border-y border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid lg:grid-cols-3 gap-12">
          <Reveal className="lg:sticky lg:top-32 lg:self-start">
            <Overline>Why Choose Us</Overline>
            <h2 className="font-serif-lux mt-5 text-4xl md:text-5xl leading-tight tracking-tight">
              A partner you can <span className="text-gold-gradient italic">build</span> with.
            </h2>
            <p className="mt-6 text-[#b8b8b8] leading-relaxed">
              From premium products to professional guidance, we bring together everything that makes an interior project effortless — for homeowners, designers and builders alike.
            </p>
          </Reveal>

          <div className="lg:col-span-2 grid sm:grid-cols-2 xl:grid-cols-3 gap-px bg-white/5 border border-white/5">
            {WHY_CHOOSE.map((w, i) => {
              const Icon = Icons[w.icon] || Icons.Star;
              return (
                <Reveal key={w.title} delay={i * 0.05}>
                  <div className="group h-full bg-[#050505] p-7 hover:bg-[#0d0d0d] transition-colors duration-500" data-testid={`why-item-${i}`}>
                    <Icon size={26} strokeWidth={1.2} className="text-[#e7c15a] transition-transform duration-500 group-hover:-translate-y-1" />
                    <h3 className="mt-6 font-serif-lux text-xl text-[#fafafa]">{w.title}</h3>
                    <div className="mt-4 h-px w-8 bg-[#e7c15a]/40 group-hover:w-16 transition-all duration-500" />
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
